import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Tortoise silhouette uses the ★1 tier art. The active rendering
// for Stone Tortoise goes through TIERED_GLYPHS (see tieredGlyphs.ts)
// which routes ★2/★3 to the richer tier images extracted from
// assets/stone_tortoise_3tier.jpg.
export const Tortoise = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/tortoise-1.png" size={size} alt="tortoise" />
)
